var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader mt-3 mb-3 gray tc"},[_c('ico',{attrs:{"icon":"spinner","spin":"","size":_vm.size+'x'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }